module.exports = __webpack_public_path__ + "static/img/bg1.5752a72a.png";